"use client";
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { Config } from "./client";
import { ClientAssets } from "./client-assets-config/marketplace/client-assets";
import { ClientStringConstants } from "./client-assets-config/marketplace/string-constants";
import {
  createNewInstanceForAssets,
  createNewInstanceForStringConstants,
  getClientConfig,
} from "./project-config";
import ToastUtils from "../toast/toast-utils";

interface ClientConfigProvider {
  config?: Config;
  clientAssets?: ClientAssets;
  getImagePath: (image: string) => string;
  getImageWithBasePath: (image: string) => string;
  StringConstantsInstance?: ClientStringConstants;
}

var ConfigProviderContext = createContext<ClientConfigProvider>({
  config: undefined,
  getImagePath: () => {
    return "";
  },
  getImageWithBasePath: () => {
    return "";
  },
  StringConstantsInstance: undefined,
});

export function ConfigProviderWrapper({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<Config>();
  const [isCssLoaded, setIsCssLoaded] = useState(false);
  const [isAssetsLoaded, setIsAssetsLoaded] = useState(false);
  const [clientAssets, setClientAssets] = useState<ClientAssets>();

  const [constantInstance, setStringConstantInstance] =
    useState<ClientStringConstants>();
  useEffect(() => {
    setUpProjectWiseCSS();

    getSetConfig();
  }, []);

  useEffect(() => {
    ToastUtils.setToastVersion(config?.designVersion ?? "v1");
  }, [config?.designVersion]);

  const getSetConfig = async () => {
    const config = await getClientConfig();
    const StringConstant = await createNewInstanceForStringConstants();
    const AssetsConstant = await createNewInstanceForAssets();
    setConfig(config);
    setStringConstantInstance(new StringConstant());
    setClientAssets(new AssetsConstant());
  };

  // const StringConstantsInstance = (type: string) => {
  //   switch (type) {
  //     case "THRIWE_APP":
  //       return setconstantInstance(new ClientStringConstants());
  //     case "ICICI_V1":
  //       return setconstantInstance(new IciciStringConstants());
  //     case "HSBC_BEACH_CLUB":
  //       return setconstantInstance(new HsbcStringConstants());
  //     default:
  //       return setconstantInstance(new ClientStringConstants());
  //   }
  // };
  // function setupClientAssets() {
  //   const ProjectName = process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET;
  //   console.log("Setting up client assets for ", ProjectName);

  //   const NamedExportComponent = dynamic(() =>
  //     import(
  //       `@/app/config/client-assets-config/${ProjectName}/client-assets`
  //     ).then((mod) => {
  //       return mod.IciciFlavorAssets;
  //     })
  //   );

  //   console.log(
  //     "NamedExportComponent check",
  //     ` @/app/config/client-assets-config/${ProjectName}/client-assets`,
  //     NamedExportComponent
  //   );

  //   import(`@/app/config/client-assets-config/${ProjectName}/client-assets.ts`)
  //     .then((module) => {
  //       console.log("done setting up client assets for", ProjectName, module);
  //       /* for (const [key, value] of Object.entries(workflow)) {
  //       document.documentElement.style.setProperty(`--${key}`, value);
  //     } */
  //       setIsAssetsLoaded(true);
  //     })
  //     .catch((error) => {
  //       console.error("Error loading file:", error);
  //       setIsAssetsLoaded(false);
  //     });
  // }

  function setUpProjectWiseCSS() {
    const ProjectName = process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET;
    console.log("Setting up project name", ProjectName);

    import(`@/app/config/client-assets-config/${ProjectName}/all-css.scss`)
      .then((module) => {
        console.log("File 1 loaded");
        /* for (const [key, value] of Object.entries(workflow)) {
        document.documentElement.style.setProperty(`--${key}`, value);
      } */
        setIsCssLoaded(true);
      })
      .catch((error) => {
        console.error("Error loading file:", error);
        setIsCssLoaded(false);
      });
  }

  if (!isCssLoaded) {
    return <div></div>;
  }

  function getImagePath(image: string) {
    const path = `/client-assets/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/${image}`;
    return path;
  }

  function getImageWithBasePath(json: string) {
    // const path = `/client-assets/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/${image}`;
    return "";
  }

  return (
    <ConfigProviderContext.Provider
      value={{
        config: config,
        clientAssets: clientAssets,
        getImagePath: getImagePath,
        getImageWithBasePath: getImageWithBasePath,
        StringConstantsInstance: constantInstance,
      }}
    >
      {children}
    </ConfigProviderContext.Provider>
  );
}

export function useClientConfigProvider() {
  return useContext(ConfigProviderContext);
}
